import LoginPanel from './LoginPanel';

export default LoginPanel;
